var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.value)?_c('i',{staticClass:"fe fe-x text-muted text-faded"}):_c('i',{staticClass:"fe fe-check-circle text-success"})])
}
var staticRenderFns = []

export { render, staticRenderFns }